/* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import GestureHandler from "./GestureHandler";
import { TEST_MAX_IF_NOT_NAN } from "./utils";
var DiscreteGestureHandler = /*#__PURE__*/ function(GestureHandler) {
    "use strict";
    _inherits(DiscreteGestureHandler, GestureHandler);
    var _super = _create_super(DiscreteGestureHandler);
    function DiscreteGestureHandler() {
        _class_call_check(this, DiscreteGestureHandler);
        return _super.apply(this, arguments);
    }
    _create_class(DiscreteGestureHandler, [
        {
            key: "isDiscrete",
            get: function get() {
                return true;
            }
        },
        {
            key: "shouldEnableGestureOnSetup",
            get: function get() {
                return true;
            }
        },
        {
            key: "shouldFailUnderCustomCriteria",
            value: function shouldFailUnderCustomCriteria(param, param1) {
                var x = param.x, y = param.y, deltaX = param.deltaX, deltaY = param.deltaY, maxDeltaX = param1.maxDeltaX, maxDeltaY = param1.maxDeltaY, maxDistSq = param1.maxDistSq, shouldCancelWhenOutside = param1.shouldCancelWhenOutside;
                if (shouldCancelWhenOutside) {
                    if (!this.isPointInView({
                        x: x,
                        y: y
                    })) {
                        return true;
                    }
                }
                return TEST_MAX_IF_NOT_NAN(Math.abs(deltaX), maxDeltaX) || TEST_MAX_IF_NOT_NAN(Math.abs(deltaY), maxDeltaY) || TEST_MAX_IF_NOT_NAN(Math.abs(deltaY * deltaY + deltaX * deltaX), maxDistSq);
            }
        },
        {
            key: "transformNativeEvent",
            value: function transformNativeEvent(param) {
                var _param_center = param.center, x = _param_center.x, y = _param_center.y;
                // @ts-ignore FIXME(TS)
                var rect = this.view.getBoundingClientRect();
                return {
                    absoluteX: x,
                    absoluteY: y,
                    x: x - rect.left,
                    y: y - rect.top
                };
            }
        },
        {
            key: "isGestureEnabledForEvent",
            value: function isGestureEnabledForEvent(param, _recognizer, param1) {
                var minPointers = param.minPointers, maxPointers = param.maxPointers, maxDeltaX = param.maxDeltaX, maxDeltaY = param.maxDeltaY, maxDistSq = param.maxDistSq, shouldCancelWhenOutside = param.shouldCancelWhenOutside, pointerLength = param1.maxPointers, center = param1.center, deltaX = param1.deltaX, deltaY = param1.deltaY;
                var validPointerCount = pointerLength >= minPointers && pointerLength <= maxPointers;
                if (this.shouldFailUnderCustomCriteria(_object_spread_props(_object_spread({}, center), {
                    deltaX: deltaX,
                    deltaY: deltaY
                }), {
                    maxDeltaX: maxDeltaX,
                    maxDeltaY: maxDeltaY,
                    maxDistSq: maxDistSq,
                    shouldCancelWhenOutside: shouldCancelWhenOutside
                }) || // A user probably won't land a multi-pointer tap on the first tick (so we cannot just cancel each time)
                // but if the gesture is running and the user adds or subtracts another pointer then it should fail.
                !validPointerCount && this.isGestureRunning) {
                    return {
                        failed: true
                    };
                }
                return {
                    success: validPointerCount
                };
            }
        }
    ]);
    return DiscreteGestureHandler;
}(GestureHandler);
export default DiscreteGestureHandler;
